import { reclaimCampaignRuleSchema } from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import * as z from "zod";

/**
 * Holds an onboarding link's campaign code against the team so it survives the
 * Shopify OAuth round-trip, which drops query params.
 */
export const recordReclaimCampaignTouch = {
  name: "recordReclaimCampaignTouch" as const,
  input: z.object({ code: z.string().min(1).max(200) }),
  output: z.object({
    /** The matched campaign, or null when the code is unknown or disabled. */
    campaign: reclaimCampaignRuleSchema.nullable(),
  }),
};
